import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CFRD_FACILITIES } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={CFRD_FACILITIES} id={id} />;
}

export const Route = createFileRoute("/_app/cfrd/facilities/$id")({
  component: Edit,
});
